<template>
  <div class="app">
    <nav-bar />
    <router-view />
  </div>
</template>

<script>
import NavBar from './components/NavBar.vue'

export default {
  name: 'App',
  components: {
    NavBar
  }
}
</script>

<style>
:root {
  --background: #2F2E2E;
  --secondary-background: #454545;
  --accent: #383d6b;
  --accent-secondary: #383d6b;
  --text-primary: #D6D1CE;
  --text-secondary: #E6E1DE;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Halenoir', sans-serif;
  background-color: var(--background);
  color: var(--text-primary);
}

.app {
  min-height: 100vh;
}
</style>